import { createIcon } from './createIcon'

export const MinusIcon = createIcon({
  displayName: 'MinusIcon',
  viewBox: '0 0 11 2',
  path: [
    <path
      d="M1 1H10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
